import React, { useEffect } from 'react';
import { Trophy, RefreshCw, Share2, Award } from 'lucide-react';
import { useGame } from '../contexts/GameContext';
import confetti from 'react-confetti';

const GameOver = () => {
  const { score, errorMessage, wordChain, setGameState } = useGame();
  
  // Show confetti for high scores
  useEffect(() => {
    if (score > 10) {
      const confettiInstance = confetti({
        particleCount: 100,
        spread: 70,
        origin: { y: 0.6 }
      });
      
      // Stop after a few seconds
      setTimeout(() => {
        confettiInstance.reset();
      }, 3000);
    }
  }, [score]);
  
  // Generate a shareable message
  const shareScore = () => {
    const shareText = `مەن ئۇيغۇرچە سۆز زەنجىرى ئويۇنىدا ${score} نومۇر توپلىدىم! ${wordChain.length} سۆزنى زەنجىردەك باغلىدىم. سىزمۇ سىناپ بېقىڭ!`;
    
    if (navigator.share) {
      navigator.share({
        title: 'ئۇيغۇرچە سۆز زەنجىرى ئويۇنى',
        text: shareText,
      })
      .catch((error) => console.error('Sharing failed:', error));
    } else {
      // Fallback for browsers that don't support the Web Share API
      try {
        navigator.clipboard.writeText(shareText);
        alert('نەتىجە كۆچۈرۈلدى! ئۇنى دوستلىرىڭىزغا ھەمبەھىرلىيەلەيسىز.');
      } catch (error) {
        console.error('Clipboard copy failed:', error);
      }
    }
  };
  
  return (
    <div className="game-card text-center">
      <h2 className="text-2xl font-semibold mb-4 uyghur-text">ئويۇن ئاخىرلاشتى!</h2>
      
      {errorMessage && (
        <div className="mb-6">
          <p className="text-red-500 uyghur-text">{errorMessage}</p>
        </div>
      )}
      
      <div className="mb-8">
        <div className="w-20 h-20 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <Trophy size={40} className="text-emerald-600" />
        </div>
        <p className="text-gray-700 mb-2 uyghur-text">سىزنىڭ نومۇرىڭىز:</p>
        <p className="text-4xl font-bold text-emerald-600">{score}</p>
        <p className="text-gray-500 mt-2 uyghur-text">
          {score === 0 
            ? 'ئەپسۇس، سىز ھېچقانداق نومۇر توپلىيالمىدىڭىز.' 
            : `سىز جەمئىي ${wordChain.length} سۆزنى زەنجىردەك باغلىدىڭىز!`}
        </p>
      </div>
      
      {wordChain.length > 0 && (
        <div className="mb-8">
          <h3 className="text-lg font-semibold mb-2 uyghur-text">ئىشلەتكەن سۆزلىرىڭىز:</h3>
          <div className="flex flex-wrap justify-center gap-2 max-h-32 overflow-y-auto p-2">
            {wordChain.map((item, index) => (
              <div 
                key={index}
                className={`px-3 py-1 rounded text-sm flex items-center ${
                  item.player === 'player' 
                    ? 'bg-emerald-50 text-emerald-700 border border-emerald-200' 
                    : 'bg-blue-50 text-blue-700 border border-blue-200'
                }`}
              >
                {item.player === 'player' ? (
                  <Award size={12} className="mr-1" />
                ) : (
                  <Trophy size={12} className="mr-1" />
                )}
                <span className="uyghur-text">{item.word}</span>
              </div>
            ))}
          </div>
        </div>
      )}
      
      <div className="flex flex-col sm:flex-row justify-center gap-3">
        <button
          onClick={() => setGameState('setup')}
          className="btn btn-primary flex items-center justify-center gap-2"
        >
          <RefreshCw size={18} />
          <span className="uyghur-text">قايتا ئويناش</span>
        </button>
        
        <button
          onClick={shareScore}
          className="btn btn-outline flex items-center justify-center gap-2"
        >
          <Share2 size={18} />
          <span className="uyghur-text">ھەمبەھىرلەش</span>
        </button>
      </div>
      
      {score > 0 && score <= 5 && (
        <div className="mt-6 p-3 bg-blue-50 rounded-lg text-blue-700 uyghur-text">
          <p>ياخشى باشلىدىڭىز! داۋاملىق تىرىشىپ، تېخىمۇ كۆپ نومۇر توپلاڭ.</p>
        </div>
      )}
      
      {score > 5 && score <= 15 && (
        <div className="mt-6 p-3 bg-green-50 rounded-lg text-green-700 uyghur-text">
          <p>ناھايىتى ياخشى! سىزنىڭ ئۇيغۇرچە سۆز بايلىقىڭىز ئوتتۇراھال ئىكەن.</p>
        </div>
      )}
      
      {score > 15 && (
        <div className="mt-6 p-3 bg-purple-50 rounded-lg text-purple-700 uyghur-text">
          <p>ئاجايىپ! سىز ھەقىقەتەن ئۇيغۇرچە سۆزلەرنى ناھايىتى ياخشى بىلىدىكەنسىز!</p>
        </div>
      )}
    </div>
  );
};

export default GameOver;